<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col cols="12">
                <v-data-table
                    class="custom-data-table elevation-1"
					dense
					:headers="instrumentCategoryHeaders"
					:loading="$store.getters['instrumentCategory/loading']"
					:items="$store.getters['instrumentCategory/instrumentCategories']"
					:items-per-page="10"
					:search="instrumentCategorySearch"
				>
					<template v-slot:top>
						<v-toolbar dense color="white" :elevation="1" height="34px" class="custom-toolbar mb-2">
							<v-toolbar-title class="subtitle-2">Instrument Category List</v-toolbar-title>
							<v-divider class="mx-4" inset vertical></v-divider>
                            <v-form class="custom-form"> 
                                <v-text-field v-model="instrumentCategorySearch" dense single-line hide-details outlined placeholder="Search Instrument Category" autocomplete="off" class="table-search">
                                    <v-icon slot="append">mdi-magnify</v-icon>
                                </v-text-field>
                            </v-form>
                            <v-spacer></v-spacer>
                            <instrument-category-dialog :icon="true" ref="instumentCategoryDialog"></instrument-category-dialog>
						</v-toolbar>
					</template>
					<template v-slot:[`item.action`]="{ item }">
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-icon small @click="editInstumentCategory(item)" color="primary" v-on="on">mdi-circle-edit-outline</v-icon>
							</template>
							<span>Edit</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-icon small @click="instrumentCategoryDeleteId = item.id; $refs.confirmDialog.dialog = true" color="error" v-on="on" >mdi-delete-circle-outline</v-icon>
							</template>
							<span>Delete</span>
						</v-tooltip>
					</template>
				</v-data-table>
                <confirm-dialog ref="confirmDialog" @confirm="deleteInstrumentCategory"></confirm-dialog>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import confirmDialog from "./../../../components/Confirm";
import InstrumentCategoryDialog from "./../../../components/InstrumentCategory";

export default {
    name: 'InstrumentCategory',
    components: {
		"confirm-dialog": confirmDialog,
		InstrumentCategoryDialog,
    },

    data: ()=> ({
        instrumentCategoryHeaders: [
            { text: 'Sl', value: 'sl' },
            { text: 'Name', value: 'name' },
            { text: 'Action ', value: 'action' },
        ],
        instrumentCategorySearch: '',
        instrumentCategoryDeleteId: null,
    }),

    created() {
        this.$store.dispatch('instrumentCategory/getInstrumentCategories')
    },

    methods: {

        async editInstumentCategory(instrumentCategory) {
           Object.keys(this.$refs.instumentCategoryDialog.instrumentCategory).forEach(key => {
                this.$refs.instumentCategoryDialog.instrumentCategory[key] = instrumentCategory[key];
            })

            this.$refs.instumentCategoryDialog.showInstrumentCategoryDialog = true;
        },

        deleteInstrumentCategory() {
            this.$store.dispatch('instrumentCategory/deleteInstrumentCategory', { id: this.instrumentCategoryDeleteId });
            this.$refs.confirmDialog.dialog = false;
        },
    }
}
</script>

<style lang="scss" scoped>
</style>